import React, { useState, useEffect } from "react";
import "./index.css";
import CryptoImageWithBackground from "./CryptoImage";


const AccountDashboard = () => {
  const [cryptocurrencies, setCryptocurrencies] = useState([]);

  useEffect(() => {
    const fetchCryptocurrencies = async () => {
      try {
        const response = await fetch(
          "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=50&page=1&sparkline=false"
        );
        if (!response.ok) {
          throw new Error("Failed to fetch cryptocurrencies.");
        }
        const data = await response.json();
        setCryptocurrencies(data);
      } catch (error) {
        console.error("Error fetching cryptocurrencies:", error);
      }
    };

    fetchCryptocurrencies();
  }, []);

  return (
    <div className="account-dashboard">
      <h3>Popular Cryptocurrencies</h3>
      <div className="crypto-list">
        {cryptocurrencies.length > 0 ? (
          cryptocurrencies.map((crypto) => (
            <CryptoImageWithBackground
              key={crypto.id}
              image={crypto.image}
              name={crypto.name}
              symbol={crypto.symbol.toUpperCase()}
              currentPrice={crypto.current_price.toFixed(2)}
              priceChange={crypto.price_change_percentage_24h.toFixed(2)}
            />
          ))
        ) : (
          <p>Loading cryptocurrencies...</p>
        )}
      </div>
    </div>
  );
};

export default AccountDashboard;
